import React, { useState } from 'react';
import '../styles/IntelligenceWorkspace.css';

export default function PageGuide({ purpose, steps = [], metrics = [] }) {
  const [open, setOpen] = useState(false);
  return (
    <section className="page-guide">
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        <span>
          <b>How to use this page</b>
          <small>{purpose}</small>
        </span>
        <span>{open ? '−' : '+'}</span>
      </button>
      {open && (
        <div className="page-guide-body">
          <div>
            <h4>Use it in this order</h4>
            <ol>
              {steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </div>
          <div>
            <h4>What the measures mean</h4>
            <dl>
              {metrics.map((metric) => (
                <React.Fragment key={metric.name}>
                  <dt>{metric.name}</dt>
                  <dd>{metric.definition}</dd>
                </React.Fragment>
              ))}
            </dl>
          </div>
        </div>
      )}
    </section>
  );
}

export function PageTabs({ items, active, onChange }) {
  return (
    <nav className="page-tabs" aria-label="Page sections">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          className={active === item.id ? 'active' : ''}
          onClick={() => onChange(item.id)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}

export function StatusKey() {
  return (
    <div className="status-key" aria-label="Status meaning">
      <span className="red">Needs attention</span>
      <span className="amber">Monitor</span>
      <span className="green">Positive</span>
      <span className="grey">Not enough evidence</span>
    </div>
  );
}
